import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline, ThemeProvider } from '@mui/material'
import App from './App'
import { theme } from './styles/theme'
import { AuthProvider } from './contexts/AuthContext'
import { CartProvider } from './contexts/CartContext'
import { WarzoneCoinsProvider } from './contexts/WarzoneCoinsContext'
import { PalworldPerfilProvider } from './contexts/PalworldPerfilContext'
import { PalworldCartProvider } from './contexts/PalworldCartContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <PalworldPerfilProvider>
          <WarzoneCoinsProvider>
            <PalworldCartProvider>
              <CartProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </CartProvider>
            </PalworldCartProvider>
          </WarzoneCoinsProvider>
        </PalworldPerfilProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
)
